/** Top-level layout route element.
 *
 * Lives inside the data router, so providers nested here can use router hooks
 * (most importantly, `AuthProvider` calls `useNavigate()` to redirect on 401).
 */
import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthProvider';
import { DocumentTitle } from '@/components/DocumentTitle';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { SnackbarProvider } from '@/components/Snackbar';

export function RootLayout() {
  return (
    <ErrorBoundary>
      {/* Above AuthProvider on purpose — it withholds its children until the
          session is hydrated, and the tab should be titled before then. */}
      <DocumentTitle />
      <SnackbarProvider>
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  );
}
